module.exports = __webpack_public_path__ + "img/1_5.82e7ece5.png";